import { createTheme } from '@material-ui/core/styles';

const darkBlue = '#002677';

export default createTheme({
  palette: {
    common: {
      darkBlue
    }
  },
  typography: {
    h1: {
      fontFamily: 'halesWorthM',
      fontSize: '62px',
      lineHeight: '76px'
    },
    h2: {
      fontFamily: 'halesWorthM',
      fontSize: '20px',
      lineHeight: '28px'
    },
    caption: {
      fontFamily: 'cnnSansLightItal',
      fontSize: '14px',
      lineHeight: '14px'
    },
    h3: {
      fontFamily: 'cnnSansCondensedMed',
      fontSize: '22px',
      lineHeight: '24px',
      letterSpacing: '.5px',
      color: darkBlue
    },
    body1: {
      fontFamily: 'cnnSansLight',
      fontSize: '20px',
      lineHeight: '32px'
    },
    body2: {
      fontFamily: 'cnnSansMed',
      fontSize: '20px',
      lineHeight: '32px'
    }
  }
});
